import api from '../api'

export default {

  products: async (page, take, sortBy, sortOrder, search, filters) => {
    return api.get(`api/products?page=${page}&take=${take}&sort_by=${sortBy}&sort_order=${sortOrder}&search=${search}&filters=${filters}`)
  },

  productsPricing: async (page, take, sortBy, sortOrder, search, filters) => {
    return api.get(`api/products?page=${page}&take=${take}&sort_by=${sortBy}&sort_order=${sortOrder}&search=${search}&filters=${filters}&pricing=true`)
  },

  pricingBranches: async () => {
    return api.get('api/product-branch-prices/branches')
  },

  branchPricing: async (branchId, page, take, sortBy, sortOrder, search, filters) => {
    return api.get(`api/product-branch-prices/${branchId}`, {
      params: {
        page, take, sort_order: sortOrder, search, filters,
        sort_by: sortBy === 'mandate_pricing_min' ? 'effective_mandate_pricing_min' : sortBy
      }
    })
  },

  branchPriceListPdf: async (branchId) => {
    return api.get(`api/product-branch-prices/${branchId}/pdf`, { responseType: 'blob' })
  },

  updateBranchPrice: async (branchId, productId, prices) => {
    return api.patch(`api/product-branch-prices/${branchId}/${productId}`, prices)
  },

  resetBranchPrice: async (branchId, productId) => {
    return api.delete(`api/product-branch-prices/${branchId}/${productId}`)
  },

  createGetData: async ()=> {
    return api.get('api/products/create')
  },

  create: async product => {
    return api.post('api/products', product)
  },

  checkDuplicate: async code => {
    return api.post('api/products/duplicate-check',{code:code})
  },

  get: async id => {
    return api.get('api/products/' + id)
  },

  update: async (id,product) => {
    return api.put('api/products/' + id, product)
  },

  delete: async id => {
    return api.delete('api/products/' + id)
  },

  comment: async (product,comment) => {
    return api.post(`api/products/${product.id}/comment`,comment)
  },

  commentDelete: async (product,comment) => {
    return api.delete(`api/products/${product.id}/comment/${comment.id}`)
  },
}
